import { useQuery } from '@tanstack/react-query';
import { getOnboardingProgress } from './api';
import type { OnboardingProgress } from './completion';
export type { OnboardingProgress } from './completion';

export const ONBOARDING_PROGRESS_QUERY_KEY = ['onboarding-progress'] as const;

export const useOnboardingProgressQuery = () => {
  return useQuery<OnboardingProgress>({
    queryKey: ONBOARDING_PROGRESS_QUERY_KEY,
    queryFn: () => getOnboardingProgress(),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
